export default "__VITE_ASSET__B5brD9Yr__"